import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4887b161&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4887b161&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4887b161&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=4887b161&lang=scss&scoped=true"
import style3 from "./index.vue?vue&type=style&index=3&id=4887b161&lang=scss&scoped=true"
import style4 from "./index.vue?vue&type=style&index=4&id=4887b161&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887b161",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4887b161')) {
      api.createRecord('4887b161', component.options)
    } else {
      api.reload('4887b161', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4887b161&scoped=true", function () {
      api.rerender('4887b161', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/viewNumber/index.vue"
export default component.exports